import { IsNotEmpty, IsArray, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { FormCommonSectionDto } from './form.common.section.dto';
import { FormSettingsSectionDto } from './form.settings.section.dto';
import { FormQuestionsSectionDto } from './form.questions.section.dto';

export class FormDto {
  @Type(() => FormCommonSectionDto)
  @ValidateNested()
  common: FormCommonSectionDto;

  @ValidateNested({ each: true })
  @Type(() => FormQuestionsSectionDto)
  @IsArray()
  @IsNotEmpty({ message: 'Обязательное поле' })
  questions: FormQuestionsSectionDto[];

  @Type(() => FormSettingsSectionDto)
  @ValidateNested()
  settings: FormSettingsSectionDto;
}
